import React from 'react';
import PropTypes from 'prop-types';
import BaseCalloutSection from './BaseCalloutSection';

const buttonUrl = 'https://www.cirium.com/thoughtcloud/visualization-impact-coronavirus-aviation/';
const imgUrl = 'https://assets.flightstats.com/home/Homepage-Card_covid19.jpg';
const title = 'COVID-19 (coronavirus) impacts on global and regional travel';
const subtitle = 'View visualizations, videos and posts';
const buttonTitle = 'AVIATION IMPACT';
const buttonPressString = 'covid19AviationImpact';

const COVID19Section = ({ reportButtonPress }) => (
  <BaseCalloutSection
    reportButtonPress={reportButtonPress}
    buttonUrl={buttonUrl}
    imgUrl={imgUrl}
    imgAlt={title}
    title={title}
    subtitle={subtitle}
    buttonTitle={buttonTitle}
    buttonPressString={buttonPressString}
    buttonColor='#DF004D'
  />
);

COVID19Section.propTypes = {
  reportButtonPress: PropTypes.func,
};

export default COVID19Section;



// WEBPACK FOOTER //
// ./modules/Homepage/components/COVID19Section.js